import React, { useRef, useState } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    Media
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import MessageBox from "../../../components/ui/MessageBox";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import "antd/dist/antd.css";

import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/bookassignment/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.bookassignment.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC]: { done: this._handleSaveBookAssignmentAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        const partnerId = this.props.partner ? this.props.partner.id : null;
        this.props.loadScreenViewAsync({ partnerId, id });
    }

    render() {
        const { bookAssignment } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!bookAssignment || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveBookAssignment}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_BOOK_ASSIGNMENT_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveBookAssignment = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: (this.props.partner ? this.props.partner.id : null) };
                        this.props.saveBookAssignmentAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveBookAssignmentAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { bookAssignment, courseTypes, courses } = props.localState;
    const { id, course } = bookAssignment || {};
    const { id: courseId, type: courseType } = course || {};
    const { register, handleSubmit, errors, setValue } = useForm();
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("bookAssignment")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("back")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    {/*<div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("courseType")}</label>
                                    <select
                                        className="form-control-alternative form-control"
                                        name="courseType"                                                             
                                        defaultValue={courseType}
                                        onChange={e => props.selectCourseType(parseInt(e.target.value))}
                                        ref={register({ 
                                            required: props.t("fieldIsRequired") 
                                        })}>
                                            <option value="">{props.t("selectACourseType")}</option>
                                            {Object.entries(courseTypes).map(([key, value], i) => {
                                                return <option key={i} value={key}>{props.t(value)}</option>
                                            })}
                                    </select>
                                    {errors.courseType && <span className="text-danger">{errors.courseType.message}</span>}
                                </div>
                            </div>                            
                        </div>
                    </div>*/}
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("courseName")}</label>
                                    <select
                                        className="form-control-alternative form-control"
                                        name="courseId"                                                             
                                        defaultValue={courseId}
                                        ref={register({ 
                                            required: props.t("fieldIsRequired") 
                                        })}>
                                            <option value="">{props.t("selectACourseName")}</option>
                                            {courses && courses/*.filter(c => c.type === courseType)*/.map((item, i) => {
                                                return <option key={i} value={item.id}>{Helper.subString(item.title, 0, 30, true)}</option>
                                            })}
                                    </select>
                                    {errors.courseId && <span className="text-danger">{errors.courseId.message}</span>}
                                </div>
                            </div>                            
                        </div>
                    </div>                    
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,        
        partner: state.session.partner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: vo => dispatch(Actions.loadScreenViewAsync(vo)),
        saveBookAssignmentAsync: vo => dispatch(Actions.saveBookAssignmentAsync(vo)),
        selectCourseType: courseType => dispatch(Actions.selectCourseType(courseType))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));